import request from '@/utils/request'

// 查询维修服务列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/service/page',
        method: 'get',
        params: query,
    })
}
// 查询维修服务详细
export function getObj(id) {
    return request({
        url: '/upkeep/service/detail?id=' + id,
        method: 'get',
    })
}
// 新增维修服务
export function addObj(data) {
    return request({
        url: '/upkeep/service/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用 维修首页状态
export function statusObj(data) {
    return request({
        url: '/upkeep/service/status',
        method: 'post',
        data: data,
    })
}
// 修改维修服务
export function putObj(data) {
    return request({
        url: '/upkeep/service/edit',
        method: 'post',
        data: data,
    })
}
// 删除维修服务
export function delObj(data) {
    return request({
        url: '/upkeep/service/delete',
        method: 'post',
        data: data,
    })
}
